import { ISimpleAccountResponse } from '@/domains/AccountDomain'

import { call } from '../core'

/**
 * ISimpleAccountResponse
 *
 * acctNo: 계좌번호
 * acctTitle: 계좌이름
 * baseAcctCcy: 계좌통화코드
 * baseCurJan: 지급가능금액
 * debitCardYn: debit발급여부
 * dpAcctYn: 대표계좌여부
 * payYn: 지급가능여부
 * subjCd: 상품유형코드
 * acctColor: 색상코드
 */

export interface IAccountInfoResult {
  result: ISimpleAccountResponse | null
}

export function getMyAccount(): Promise<IAccountInfoResult | Error> {
  return call('finGetMyAccount')
}
